/* === CRO Home Carousels — wraps each slider with center-side arrows + conditional visibility === */
(function () {
  if (window.__CRO_HOME_CAROUSEL__) return;
  window.__CRO_HOME_CAROUSEL__ = true;

  var ARROW_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

  function makeArrow(dir) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cro-home-arrow cro-home-arrow--' + dir;
    btn.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
    btn.innerHTML = dir === 'prev' ? ARROW_PREV : ARROW_NEXT;
    return btn;
  }

  function setArrowState(wrap, scroller) {
    var max = scroller.scrollWidth - scroller.clientWidth;
    if (max <= 2) {
      wrap.classList.remove('cro-has-prev', 'cro-has-next');
      return;
    }
    var x = scroller.scrollLeft;
    wrap.classList.toggle('cro-has-prev', x > 2);
    wrap.classList.toggle('cro-has-next', x < max - 2);
  }

  function attachCarousel(wrap, scroller) {
    if (wrap.dataset.croCarouselBound) return;
    wrap.dataset.croCarouselBound = '1';
    wrap.classList.add('cro-home-carousel');

    var prev = makeArrow('prev');
    var next = makeArrow('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function scrollBy(dir) {
      var step = scroller.clientWidth * 0.85;
      scroller.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { scrollBy(-1); });
    next.addEventListener('click', function () { scrollBy(1); });

    scroller.addEventListener('scroll', function () { setArrowState(wrap, scroller); }, { passive: true });
    window.addEventListener('resize', function () { setArrowState(wrap, scroller); });

    // initial state
    setTimeout(function () { setArrowState(wrap, scroller); }, 200);
    setTimeout(function () { setArrowState(wrap, scroller); }, 800);
  }

  function initFeaturedCollections() {
    // Only wrap PRODUCT carousels (product-grid). Skip multicolumn, testimonial, blog sliders.
    var sliders = document.querySelectorAll('slider-component .product-grid.slider, slider-component ul.product-grid.slider');
    sliders.forEach(function (scroller) {
      var sc = scroller.closest('slider-component');
      if (!sc) return;
      var wrap = sc.parentElement;
      if (!wrap.classList.contains('cro-home-carousel-inner')) {
        var newWrap = document.createElement('div');
        newWrap.className = 'cro-home-carousel-inner';
        sc.parentNode.insertBefore(newWrap, sc);
        newWrap.appendChild(sc);
        wrap = newWrap;
      }
      attachCarousel(wrap, scroller);
    });
  }

  function initCategoryBlocks() {
    var scrollers = document.querySelectorAll('.category_blocks_wrapper');
    scrollers.forEach(function (scroller) {
      var wrap = scroller.parentElement;
      // wrap with .cro-home-carousel-inner if not already
      if (!wrap.classList.contains('cro-home-carousel-inner')) {
        var newWrap = document.createElement('div');
        newWrap.className = 'cro-home-carousel-inner';
        scroller.parentNode.insertBefore(newWrap, scroller);
        newWrap.appendChild(scroller);
        wrap = newWrap;
      }
      attachCarousel(wrap, scroller);
    });
  }

  function init() {
    initFeaturedCollections();
    initCategoryBlocks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init after section refresh (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
